import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { BrowserStorageUtil, cookieStorage } from '@swift-247/s247.library.ui-core';
import buildTimeConfig from '../../../config/buildtime.config';
import { useTranslation } from 'react-i18next';
import { Spin } from 'antd';

const MagicLink = () => {
  const [queryParams, setQueryParams] = useSearchParams();
  const token = queryParams.get('token');
  const appId = queryParams.get('appId');
  const errCode = queryParams.get('errCode') || 'session_expired';

  const {t} = useTranslation();
  const envStorage =
    buildTimeConfig.env !== 'local' ? localStorage : cookieStorage;

  useEffect(() => {
    if(!token) return;
    const loginPayload = {
      isLoggedIn: true,
      accessToken: token,
      loginType: 'magic-link',
      appId
    }

    const browserStorageUtil = new BrowserStorageUtil(envStorage as any);
    browserStorageUtil.serializedSave('authInfo', loginPayload);

    setTimeout(() => {
      window.location = '/' as any;
    }, 1000)

  }, [token, appId])

  return <div>
    <div className="header-title">
      <div className="title">{t('global_welcome')}</div>
      <div style={{textAlign: 'center'}} className="subtitle">{t('section_title_login_magic_link')}</div>
      {!!token ? <>
        <div style={{
          textAlign: 'center',
          marginTop: '10px',
          fontWeight: 500,
        }}>{t('magic_link_logging_in')}</div>
        <Spin style={{ margin: 'auto', width: '100%', marginTop: '10px' }} />
      </>: <>
        <div style={{
          textAlign: 'center',
          marginTop: '10px',
          fontWeight: 500,
        }}>{t(`magic_link_error_message_${errCode}`)}</div>
      </>}
    </div>
  </div>
}

export default MagicLink;
